
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/network-performance-analysis/create",
      function () {
        return require("private-next-pages/network-performance-analysis/create.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/network-performance-analysis/create"])
      });
    }
  